import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class SmartFeedPageLimit extends BaseOption {
  static label = "Num Per Page";
  static descriptionMessage = "Limit when fetching records";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 1,
      max: 100,
      defaultEmptyValue: 24,
    },
  };

  static defaultValue = 24;
}
